import React, { createContext, useContext, useEffect, useState } from "react";
import { api, loadToken, setToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageLimit, setImageLimit] = useState({ remaining: 5, limit: 5 });
  const [premium, setPremium] = useState(false);

  useEffect(() => {
    const t = loadToken();
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data.user);
      setPremium(r.data.premium);
      setImageLimit({ remaining: r.data.image_remaining, limit: r.data.image_limit });
    }).catch(() => setToken(null)).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.access_token);
    setUser(r.data.user);
    const me = await api.get("/auth/me");
    setPremium(me.data.premium);
    setImageLimit({ remaining: me.data.image_remaining, limit: me.data.image_limit });
    return r.data.user;
  };

  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    setToken(r.data.access_token);
    setUser(r.data.user);
    const me = await api.get("/auth/me");
    setPremium(me.data.premium);
    setImageLimit({ remaining: me.data.image_remaining, limit: me.data.image_limit });
    return r.data.user;
  };

  const logout = () => { setToken(null); setUser(null); setPremium(false); };

  const refreshLimits = async () => {
    try {
      const me = await api.get("/auth/me");
      setPremium(me.data.premium);
      setImageLimit({ remaining: me.data.image_remaining, limit: me.data.image_limit });
    } catch {}
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, imageLimit, premium, refreshLimits, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
